import {createVoidActionCreator} from '../common/actions';

export const AlbumListDependentComponentMounted = createVoidActionCreator('ALBUM_LIST_DEPENDENT_COMPONENT_MOUNTED');
export const AlbumListDependentComponentUnmounted = createVoidActionCreator('ALBUM_LIST_DEPENDENT_COMPONENT_UNMOUNTED');